<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">EQUIPOS REGISTRADOS</h5>
      </div>
      <div class="card-body">
        <div class="col-md-12 text-left mb-3">
        
           <a
            href="#"
            class="btn btn-success"
            @click="amEquipo(undefined)"
            aria-pressed="true"
            ><i class="fa fa-plus"></i
          ><small> Nuevo Equipo</small></a> 
        </div>
        <div class="text-center" v-if="cargando">
          <i class="fa fa-spinner fa-pulse fa-5x"></i>
          <h4 class="mt-2">Cargando Datos...</h4>
        </div>
        <div class="table-responsive" style="overflow-y:scroll; height:360px;">
          <table class="table table-striped table-bordered" >
            <thead>
              <tr class="text-center">
                <th><small class="font-weight-bold">NRO.</small></th>
                <th><small class="font-weight-bold">NOMBRE</small></th>
                <th><small class="font-weight-bold">CÓDIGO</small></th>
                <th><small class="font-weight-bold">IP</small></th>
                <th><small class="font-weight-bold">OPCIONES</small></th>
                <th><small class="font-weight-bold">ACCIONES</small></th>
              </tr>
            </thead> 
            <tbody>
              <tr v-for="(item, index) in equipos" :key="index">
                <td class="text-center">
                  <small>{{ index + 1 }}</small>
                </td>
                <td>
                  <small>{{ item.nombre }}</small>
                </td>
                <td>
                  <small>{{ item.codigo_scaner }}</small><br>
                </td>
                <td>
                  <small>{{ item.ip }}</small><br>
                </td>
                
                <td class="text-center">
                  <span v-if="item.estados==0" class="badge badge-success"> REINICIAR</span>
                  <span v-else class=" badge badge-danger">INACTIVO</span>
                </td>
                <td class="text-center">

                  <a v-if="item.estado_registro == 1" 
                    class="btn btn-outline-warning btn-sm mr-1"
                    title="Editar Registro"
                     @click="amEquipo(item)"
                  >
                    <i class="fa fa-edit"></i>
                  </a>
                  <a v-if="item.estados == 1"
                    class="btn btn-outline-danger btn-sm"
                    title="Baja Registro"
                    
                    ><i class="fa fa-trash"></i></a>
                  <a v-if="item.estados == 0"
                    class="btn btn-outline-success btn-sm"
                    title="Alta Registro"
                   
                    ><i class="fa fa-check"></i>
                  </a>
                  <a
                    class="btn btn-outline-danger btn-sm"
                    title="Eliminar Registro"
                   @click="bajaEquipo(item)"
                    ><i class="fa fa-trash"></i>
                  </a>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal
      class="modal fade"
      size="xl"
      hide-footer
      title="EQUIPOS"
      ref="modalEquipo"
      :no-close-on-backdrop="true"
    >
      <!-- <div class="modal-dialog modal-lg"> -->
      <div class="container mb-3">
          <div class="card">
            <div class="card-header">
              <h6 class="text-center">{{ tituloModal }}</h6>
            </div>
              <div class="card-body">   
              <div class="row">
                <div class="col-md-5">
                    
                  <div class="row form-group">
                    <div class="col-12 col-md-12">
                      <label class="font-weight-bold mr-1">nombre del Equipo:</label>
                      <span
                        class="text-danger text-help"
                        v-if="!$v.equipo.nombre.required"
                        ><small>Campo requerido</small>
                      </span>
                      <input
                        type="text"
                        placeholder="Ej.: MI-EQUIPO"
                        class="form form-control"
                        :class="{'is-invalid': $v.equipo.nombre.$error}"
                        v-model.trim="equipo.nombre"
                        @keyup="equipo.nombre = equipo.nombre.toUpperCase()"
                      />
                  
                   </div> 
                  </div>
                  <div class="row form-group">
                    <div class="col-12 col-md-12">
                      <label class="font-weight-bold mr-1">Codigo Scaner:</label>
                      <span
                        class="text-danger text-help"
                        v-if="!$v.equipo.codigo_scaner.required"
                        ><small>Campo requerido</small>
                      </span>
                      <input
                        type="text"
                        placeholder="Ej.: MI-EQUIPO"
                        class="form form-control"
                        :class="{'is-invalid': $v.equipo.codigo_scaner.$error}"
                        v-model.trim="equipo.codigo_scaner"
                        @keyup="equipo.codigo_scaner = equipo.codigo_scaner.toUpperCase()"
                      />
                  
                   </div> 
                  </div>
                  <div class="row form-group">
                    <div class="col-12 col-md-12">
                      <label class="font-weight-bold mr-1">IP EQUIPO</label>
                      <span
                        class="text-danger text-help"
                        v-if="!$v.equipo.ip.required"
                       
                        ><small>Campo requerido</small>
                      </span>
                      <input
                        type="text"
                        placeholder="Ej.: 192.168.1.1"
                        class="form form-control"
                        :class="{'is-invalid': $v.equipo.ip.$error}"
                        v-model.trim="equipo.ip"
                        
                        
                      />
                   </div> 
                  </div>

                </div>

              </div>

              <div class="row ">
                
                <div class="col-12 col-md-4"> 
                  <button @click="hideModal()" class="btn btn-secondary btn-block">
                  Cancelar
                  </button>
                </div>
                <div class="col-12 col-md-4" v-if="controBoton"> 
                  <button @click="crearEquipo()" class="btn btn-primary btn-block">Registrar</button>
                </div>
                <div class="col-12 col-md-4" v-if="!controBoton"> 
                  <button @click="updateEquipo()" class="btn btn-primary btn-block">Actualizar</button>
                </div>
              </div>
            <!-- </form> -->
            </div>
          </div>
         
        </div>
      <!-- </div> -->
    </b-modal>
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import Loading from "../../components/Loading";
//import moment from "moment";


export default {
  name: "equipos",
  data() {
    return {
      equipos: [],
      equipo:{
        nombre: "",
        ip: "",
        id_persona: "",
        codigo_scaner: "",
        estado_registro:1
      },
      controBoton: true,
      cargando: false,
      tituloModal: "Registro Empresa",
      persona: {},
     
    };
  },
  components: {
    Loading,
 
  },
  methods: {
      async getEquipo(id_persona) {
        console.log("persona:",this.persona);
      let config = { headers: { token: this.token } };
      try {
        let resultados = await this.axios.get(`/getAutomatizado/${id_persona}`,config);
        this.equipos = resultados.data.contenido;
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async amEquipo(item) {
      
      if (item == undefined) {
        this.equipo = {item};
        this.tituloModal = "NUEVO REGISTRO EQUIPO";
        this.controBoton = true;
      } else {
      
        this.equipo = item;

        this.tituloModal = "EDITAR REGISTRO";
        this.controBoton = false;
      }

      this.showModal();
    },
 
    async crearEquipo() {
      this.cargando = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.cargando = false;
        return;
      }
      //console.log("datos:",this.equipo.nombre);
      try {
          this.equipo = {
          nombre: this.equipo.nombre,
          ip: this.equipo.ip,
          codigo_scaner: this.equipo.codigo_scaner,
          id_persona: this.persona.id_persona
        } 
        let resultados = await this.axios.post(`/insert_equipo`,this.equipo);
     console.log("resultados:",resultados.data.codigo);
        if (resultados.data.codigo === 1) {
          this.cargando = false;
          this.$swal({
            title: 'Información',
            html: 'Equipo adicionada correctamente.',
            type: 'success',
            confirmButtonText: 'Aceptar'
          })
          .then((error)=>{
            if(error.value){
              this.$router.push('equipos');
              this.getEquipo(this.persona.id_persona);
            }
            
          });
         
        }
        this.hideModal();
        

      } catch (error) {
        console.log('catch: ', error);
      }
    },

    async updateEquipo() {
   
     this.equipo.estado_registro = 1;
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.cargando = false;
        return;
      }

      this.equipo.id_equipo = this.equipo.id_equipo;
      
      try {
        let resultados = await this.axios.put(`/update_equipo`, this.equipo);
        this.equipo = resultados.data.contenido;
       // let id = resultados.data.contenido.id_equipo;

        this.$swal({
          title: 'Información',
          text: 'Se Actualizo Correctamente!',
          type: 'success',
          confirmButtonText: 'Aceptar'
        });

        this.hideModal();
        this.getEquipo(this.persona.id_persona);
       // this.$router.push('equipos');
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    
    bajaEquipo(equipo) {
      this.$swal({
        title: "Esta Seguro?",
        html: "De realizar la <b>baja</b> de la Equipo.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Realizar Baja",
      })
      .then(async (result) => {
        if (result.value) {
          try {
            await this.axios.patch(`/equipo_baja`, equipo);
            this.getEquipo(this.persona.id_persona);
           
            this.$swal({
              title: 'Información',
              text: 'Se dio de Baja.',
              type: 'success',
              confirmButtonText: 'Aceptar'
            });
          } catch (error) {
            console.log(error);
          }
        }
      });
    },

    async listarDato() {
      let config = { headers: { token: this.token }};
      try {
        this.resultados = await this.axios.get(`/personaGetDataLogin`, config);
        this.persona = this.resultados.data.contenido;
       this.getEquipo(this.persona.id_persona);
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    bajaEmpresa(empresa) {
      this.$swal({
        title: "Esta Seguro?",
        html: "De realizar la <b>baja</b> de la Empresa.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Realizar Baja",
      })
      .then(async (result) => {
        if (result.value) {
          try {
            await this.axios.patch(`/empresa/baja`, empresa);
            this.getEmpresas(empresa.id_persona);
            this.$swal({
              title: 'Información',
              text: 'Se dio de Baja.',
              type: 'success',
              confirmButtonText: 'Aceptar'
            });
          } catch (error) {
            console.log(error);
          }
        }
      });
    },


    altaEmpresa(empresa) {
      this.$swal({
        title: "Estas Seguro?",
        text: "Daras de alta a la Empresa!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, dar de Alta!",
      })
      .then(async (result) => {
        if (result.value) {
          try {
            await this.axios.put(`/empresa/alta`, empresa);
            this.$swal({
              title: 'Información',
              text: 'Se dio de Alta.',
              type: 'success',
              confirmButtonText: 'Aceptar'
            });
            this.getEmpresas(empresa.id_persona);
          } catch (error) {
            console.log('catch: ', error);
          }
        }
      });
    },


    showModal() {
     
      this.$refs["modalEquipo"].show();
    },
    hideModal() {
      this.$refs["modalEquipo"].hide();
    },
  },

 
    

  created() {
   this.listarDato();
   //this.getEquipo();
   //this.crearEquipo()
    
  },
  validations: {
    equipo:{
      nombre: { required },
      ip: { required },
      codigo_scaner: { required }
    },
  },
};
</script>
